"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Logo = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _CivicClerk = _interopRequireWildcard(require("./CivicClerk"));

var _CivicEngageCentral = _interopRequireWildcard(require("./CivicEngageCentral"));

var _CivicEngageEvolve = _interopRequireWildcard(require("./CivicEngageEvolve"));

var _CivicHR = _interopRequireWildcard(require("./CivicHR"));

var _CivicOptimize = _interopRequireWildcard(require("./CivicOptimize"));

var _CivicPlus = _interopRequireWildcard(require("./CivicPlus"));

var _CivicReady = _interopRequireWildcard(require("./CivicReady"));

var _CivicRec = _interopRequireWildcard(require("./CivicRec"));

var _CivicService = _interopRequireWildcard(require("./CivicService"));

var _SeeClickFix = _interopRequireWildcard(require("./SeeClickFix"));

var _Preamble = _interopRequireWildcard(require("./Preamble"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["product", "white", "circle"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Logo = function Logo(_ref) {
  var product = _ref.product,
      white = _ref.white,
      circle = _ref.circle,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (product === "CivicClerk") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicClerk.CivicClerkLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicClerk.CivicClerkLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicClerk.default, otherProps);
    }
  }

  if (product === "CivicEngage Evolve") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageEvolve.CivicEngageEvolveLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageEvolve.CivicEngageEvolveLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageEvolve.default, otherProps);
    }
  }

  if (product === "CivicEngage Central") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageCentral.CivicEngageCentralLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageCentral.CivicEngageCentralLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicEngageCentral.default, otherProps);
    }
  }

  if (product === "CivicHR") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicHR.CivicHRLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicHR.CivicHRLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicHR.default, otherProps);
    }
  }

  if (product === "CivicOptimize") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicOptimize.CivicOptimizeLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicOptimize.CivicOptimizeLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicOptimize.default, otherProps);
    }
  }

  if (product === "CivicReady") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicReady.CivicReadyLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicReady.CivicReadyLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicReady.default, otherProps);
    }
  }

  if (product === "CivicRec") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicRec.CivicRecLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicRec.CivicRecLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_CivicRec.default, otherProps);
    }
  }

  if (product === "CivicService") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_CivicService.CivicServiceLogoWhite, otherProps);
    } else if (!circle) {
      return /*#__PURE__*/_react.default.createElement(_CivicService.default, otherProps);
    }
  }

  if (product === "SeeClickFix") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_SeeClickFix.SeeClickFixLogoWhite, otherProps);
    } else if (circle) {
      return /*#__PURE__*/_react.default.createElement(_SeeClickFix.SeeClickFixLogoCircle, otherProps);
    } else {
      return /*#__PURE__*/_react.default.createElement(_SeeClickFix.default, otherProps);
    }
  }

  if (product === "Preamble") {
    if (white) {
      return /*#__PURE__*/_react.default.createElement(_Preamble.PreambleLogoWhite, otherProps);
    } else if (!circle) {
      return /*#__PURE__*/_react.default.createElement(_Preamble.default, otherProps);
    }
  } // CivicPlus logo as the default return.


  if (white) {
    return /*#__PURE__*/_react.default.createElement(_CivicPlus.CivicPlusLogoWhite, otherProps);
  } else if (circle) {
    return /*#__PURE__*/_react.default.createElement(_CivicPlus.CivicPlusLogoCircle, otherProps);
  } else {
    return /*#__PURE__*/_react.default.createElement(_CivicPlus.default, otherProps);
  }
};

exports.Logo = Logo;
Logo.defaultProps = {
  role: "img"
};
var _default = Logo;
exports.default = _default;